import '.az{overflow:hidden;}.ssr-plugin'
import '.ic{border-radius:0 19px 0 0;}.ssr-plugin'
import '.by{position:absolute;}.ssr-plugin'
import '.id{top:-1px;}.ssr-plugin'
import '.ie{left:-1px;}.ssr-plugin'
import '.if{transform:translateX(0%);}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.ig{padding:0.1rem 0.375rem 0.375rem 0.1rem;}.ssr-plugin'
import '.ih{border-radius:0 0 1.125rem 0;}.ssr-plugin'
import '.dz{flex-shrink:1;}.ssr-plugin'
import '.ii{width:auto;}.ssr-plugin'
import '.ij{z-index:1;}.ssr-plugin'
import '.ik{top:0px;}.ssr-plugin'
import '.il{right:-18px;}.ssr-plugin'
import '.im{bottom:-20px;}.ssr-plugin'
import '.in{left:0px;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import { Title } from '@app/components/core/typography/Title'
import { Tag, Variant } from '@app/components/core/tag/Tag'
import { match } from 'ts-pattern'
import { InitiativeStatusRow } from './blocks/InitiativeStatusRow'
import Column from '@app/components/layout/Column'
import { Image } from '@app/components/core/image/Image'
import { LinkWrapper } from '@app/components/core/link/LinkWrapper'

export interface InitiativeCardProps {
  image: string
  location: string
  phase?: string
  title: string
  description?: string
  tagText: string
  tagVariant?: Variant
  variant?: 'default' | 'spotlight'
  style?: Style
  to: string
}

export const InitiativeCard = (props: InitiativeCardProps) => {
  const defaults: Partial<InitiativeCardProps> = {
    tagVariant: 'accent',
    variant: 'default',
  }

  const finalProps = { ...defaults, ...props }

  return match(finalProps.variant)
    .with('default', () => <DefaultCard {...finalProps} />)
    .with('spotlight', () => <SpotlightCard {...finalProps} />)
    .exhaustive()
}

const DefaultCard = ({
  image,
  location,
  phase,
  title,
  description,
  tagText,
  tagVariant,
  to,
  style,
}: InitiativeCardProps) => {
  return (
    <LinkWrapper
      to={to}
      data-testid="initiative-card"
      style={{
        position: 'relative',
        backgroundColor: 'var(--palette-white)',
        borderRadius: '0 20px 20px 20px',
        cursor: 'pointer',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        border: 'var(--border-subtle)',
        ...style,
      }}
    >
      <TagCutout tagText={tagText} tagVariant={tagVariant} />
      <div className="az ic"
      >
        <Image
          src={image}
          resizeWidth={500}
          style={{
            width: '100%',
            height: '224px',
            objectFit: 'cover',
            display: 'block',
          }}
        />
      </div>

      {/* Content Section */}
      <Column
        alignItems="stretch"
        style={{
          padding: '1.5rem',
          borderTop: 'var(--border-subtle)',
        }}
      >
        <InitiativeStatusRow location={location} status={phase} />
        {/* Title */}
        <Title.H4
          style={{
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            lineHeight: '120%',
            overflow: 'hidden',
            margin: 0,
          }}
        >
          {title}
        </Title.H4>
        {description && (
          <Text.Medium
            style={{
              color: 'var(--palette-blue-300)',
              lineHeight: '1.75rem',
              display: '-webkit-box',
              WebkitLineClamp: 3,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            {description}
          </Text.Medium>
        )}
      </Column>
    </LinkWrapper>
  )
}

const SpotlightCard = ({
  image,
  location,
  phase,
  title,
  description,
  tagText,
  tagVariant,
  to,
  style,
}: InitiativeCardProps) => {
  return (
    <LinkWrapper
      to={to}
      data-testid="initiative-card"
      style={{
        position: 'relative',
        backgroundColor: 'var(--palette-white)',
        borderRadius: '0 20px 20px 20px',
        overflow: 'hidden',
        cursor: 'pointer',
        width: '100%',
        display: 'flex',
        height: '23rem',
        ...style,
      }}
    >
      <TagCutout tagText={tagText} tagVariant={tagVariant} />
      {/* Image Section - Left Side */}
      <Image
        src={image}
        resizeHeight={361}
        style={{
          width: '361px',
          height: '100%',
          objectFit: 'cover',
          display: 'block',
        }}
      />

      {/* Content Section - Right Side */}
      <Column
        alignItems="stretch"
        style={{
          padding: '1.5rem',
          flex: 1,
          justifyContent: 'flex-start',
          borderRight: 'var(--border-subtle)',
          borderBottom: 'var(--border-subtle)',
          borderTop: 'var(--border-subtle)',
          borderRadius: '0 20px 20px 0',
        }}
      >
        <InitiativeStatusRow location={location} status={phase} />
        {/* Title */}
        <Title.H4 style={{ marginTop: '2.5rem' }}>{title}</Title.H4>
        {/* Description - aligned to bottom */}
        <Text.Medium
          style={{
            marginTop: '1rem',
            color: 'var(--palette-blue-300)',
            lineHeight: '1.5',
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}
        >
          {description}
        </Text.Medium>
      </Column>
    </LinkWrapper>
  )
}

const TagCutout = ({
  tagText,
  tagVariant,
}: Pick<InitiativeCardProps, 'tagText' | 'tagVariant'>) => {
  return (
    <div className="by id ie if t ig ih dz ii ij"
    >
      <div className="by ik il"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 0.00517004C11.8861 0.00178386 11.7718 0 11.6571 0C5.21908 0 0 5.37258 0 12L0 0L12 0V0.00517004Z"
            fill="var(--palette-white)"
          />
        </svg>
      </div>
      <Tag size="small" variant={tagVariant} label={tagText} />
      <div className="by im in if"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 0.00517004C11.8861 0.00178386 11.7718 0 11.6571 0C5.21908 0 0 5.37258 0 12L0 0L12 0V0.00517004Z"
            fill="var(--palette-white)"
          />
        </svg>
      </div>
    </div>
  )
}
